import { Inject } from '@odinjs/odin';

import { ENDPOINTS } from '@philips-emr/hpms-health-insurance-commons';
import { catchRenderException } from '@philips-emr/hpms-health-insurance-components';
import { ButtonAPI, FormAPI, RecaptchaAPI } from '@philips-emr/tws-components';
import Controller, { OnChange, OnClick, OnMount, OnValidate } from '@philips-emr/tws-core/lib/client';
import { HttpService, SessionStorageService } from '@philips-emr/tws-core/lib/services';

import { HealthDeclarationValidAliases as Aliases, FragmentNames } from '../../codegen';
import { BaseRoute } from '../../route';
import NoLoginBaseController from '../no-login-base-controller';
import './health-declaration.scss';

@Controller({ fragment: FragmentNames.HEALTH_DECLARATION_VALID })
class HealthDeclarationValidController extends NoLoginBaseController {

  @Inject(Aliases.BUTTON_SUBMIT_CODE)
  private buttonSubmitCode: ButtonAPI;

  @Inject(Aliases.FORM_0)
  private form: FormAPI;

  @OnMount(Aliases.ROOT_COMPONENT)
  onRootMount(): void {
    this.noLoginThemeSetUp();

    const seqInsuredDeclaration = SessionStorageService.getItem('seqInsuredDeclaration') as number;
    const { hash } = this.historyService.getCurrentRouteParams();

    if (!seqInsuredDeclaration) {
      this.historyService.push(BaseRoute.HEALTH_DECLARATION, { hash });
    }

  }

  onLeaving(): void {
    SessionStorageService.clear();
  }

  @OnValidate(Aliases.FORM_0)
  onFormValidate(): void {
    this.validateButton();
    const record = this.form.getRecord();
    let { code } = record;
    code = code?.toString().toUpperCase();
    this.form.setRecord({ ...record, code });
  }

  private validating: boolean = false;

  @OnClick(Aliases.BUTTON_SUBMIT_CODE)
  onClickSubmit(): void {
    if (this.validating) return;
    this.validating = true;
    this.validateButton();
    const { code, dtBirth } = this.form.getRecord();
    const seqInsuredDeclaration = SessionStorageService.getItem('seqInsuredDeclaration') as number;
    const { hash } = this.historyService.getCurrentRouteParams();

    HttpService.post<{ cdPhysicalPerson: string, accessHash: string }>(ENDPOINTS.POST.HEALTH_DECLARATION_CODE_VALIDATION, {},
      { body: { hash, seqInsuredDeclaration, code, dtBirth } })
      .then((response) => {
        if (!response.body) {
          this.historyService.push(BaseRoute.HEALTH_DECLARATION_INVALID);
          return;
        }
        const { cdPhysicalPerson, accessHash } = response.body;
        this.validating = false;
        this.validateButton();
        if (cdPhysicalPerson !== undefined) {
          SessionStorageService.setItem('seqInsuredDeclaration', seqInsuredDeclaration);
          SessionStorageService.setItem('cdPhysicalPerson', cdPhysicalPerson);
          SessionStorageService.setItem('accessHash', accessHash);
          this.historyService.push(BaseRoute.HEALTH_DECLARATION_DYNAMIC_FORM, { hash });
        }
        else {
          this.historyService.push(BaseRoute.HEALTH_DECLARATION_INVALID);
        }
      }).catch(() => {
        this.validating = false;
        this.validateButton();
        this.historyService.push(BaseRoute.HEALTH_DECLARATION_INVALID);
      });
  }

  private recaptchaResponse: string = '';

  validateButton(): void {
    catchRenderException(() => {
      const { code, dtBirth } = this.form.getRecord();
      this.buttonSubmitCode.setEnabled(!this.validating && code != null && dtBirth != null && this.recaptchaResponse.length > 0);
    });
  }

  @OnChange(Aliases.RECAPTCHA)
  onRecaptchaChange(event: any): void {
    const recaptcha = event.target as RecaptchaAPI;
    this.recaptchaResponse = recaptcha.getValue() as any as string;
    this.validateButton();
  }
}
export default HealthDeclarationValidController;
